<template>
  <v-container fluid class="pa-0 ma-0" style="height: 100%">
    <v-card>
      <v-card-title class="d-flex justify-space-between align-center">
        <!-- Left: Back Button -->
        <v-btn icon small @click="$emit('update')">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <!-- Center: Title -->
        <div class="text-center flex-grow-1">
          <span class="text-h6 font-weight-medium">
            Applicant Form -
            <span class="font-weight-bold">
              {{ form.applicant.application_id }}
            </span>
          </span>
        </div>

        <!-- Right: View Pending Button -->
        <div>
          <v-btn
            v-if="pendingReasons.length"
            small
            text
            class="primary--text"
            @click="dialog = true"
          >
            View Pending Reasons
          </v-btn>
          <span
            class="text-caption font-weight-medium"
            v-if="form.applicant.usn_id"
          >
            USN -
            <span class="font-weight-bold">
              {{ form.applicant.usn_id }}
            </span>
          </span>
          <span v-if="form.applicant.usn_id"> | </span>
          <span
            class="text-caption font-weight-medium"
            v-if="form.applicant.application_status"
          >
            Status -
            <span class="font-weight-bold">
              {{ form.applicant.application_status }}
            </span>
          </span>
          <span
            v-if="
              form.applicant.application_status &&
              form.applicant.partner_approval_status == 'Rejected'
            "
          >
            |
          </span>
          <span
            class="text-caption font-weight-medium"
            v-if="form.applicant.partner_approval_status == 'Rejected'"
          >
            Partner Status -
            <span class="font-weight-bold">
              {{ form.applicant.partner_approval_status }}
            </span>
          </span>
        </div>
      </v-card-title>

      <v-tabs
        v-model="activeTab"
        background-color="primary"
        show-arrows
        mobile-breakpoint="600"
        grow
      >
        <v-tabs-slider color="accent"></v-tabs-slider>
        <v-tab
          active-class="accent"
          :disabled="
            (activeTab === 1 && !isAddressValid) ||
            (activeTab === 2 && !isEducationValid)
          "
          >Applicant Details
        </v-tab>
        <v-tab
          active-class="accent"
          :disabled="
            (activeTab === 0 && !isDetailsValid) ||
            (activeTab === 2 && !isEducationValid) ||
            form.applicant.step < 1
          "
          >Address
        </v-tab>
        <v-tab
          active-class="accent"
          :disabled="
            (activeTab === 0 && !isDetailsValid) ||
            (activeTab === 1 && !isAddressValid) ||
            form.applicant.step < 2
          "
          >Education Details
        </v-tab>
        <v-tab
          active-class="accent"
          :disabled="
            (activeTab === 0 && !isDetailsValid) ||
            (activeTab === 1 && !isAddressValid) ||
            (activeTab === 2 && !isEducationValid) ||
            form.applicant.step < 3
          "
          >Declaration & Preview
        </v-tab>
      </v-tabs>

      <v-card-text class="pa-2" style="height: 100vh">
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <ApplicantDetails
              :value="form.applicant"
              @validate="validateTab($event, 'applicant')"
              @submit="handleApplicantDetailsSubmit"
              :isReadOnly="effectiveReadOnly"
            />
          </v-tab-item>

          <v-tab-item>
            <AddressDetails
              :value="form.address"
              :allForm="form.applicant"
              @validate="validateTab($event, 'address')"
              @submit="handleAddressDetailsSubmit"
              :isReadOnly="effectiveReadOnly"
            />
          </v-tab-item>

          <v-tab-item>
            <EducationDetails
              :value="form.education"
              :allForm="form.applicant"
              @input="(newEducation) => (form.education = newEducation)"
              @validate="validateTab($event, 'education')"
              @submit="handleEducationDetailsSubmit"
              :isReadOnly="effectiveReadOnly"
            />
          </v-tab-item>

          <v-tab-item>
            <DeclarationDetails
              :value="form"
              @update="$emit('update')"
              :isReadOnly="isReadOnly"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="font-weight-medium secondary--text primary">
          Pending Reasons
          <v-spacer></v-spacer>
          <v-btn small icon @click="dialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-timeline dense small class="py-0">
            <v-timeline-item
              v-for="(event, ind) in pendingReasons"
              :icon="ind !== 0 ? 'mdi-check' : ''"
              :key="ind"
              small
              class="py-2"
            >
              <div class="text-body-2 pa-0">
                <span class="font-weight-bold primary--text"
                  >{{ event.user.name }}
                </span>
                <span class="font-weight-medium text-primary"
                  >{{ " - " }} {{ event.inserted_at }}</span
                >
              </div>
              <div class="font-weight-bold text-primary">
                {{ event.reason }}
              </div>
            </v-timeline-item>
            <!-- <v-timeline-item
              v-for="(r, i) in pendingReasons"
              :key="i"
              :color="r.status === 'Open' ? 'orange' : 'green'"
              small
              :icon="r.icon"
              fill-dot
              class="py-2"
            >
              <div class="subtitle-2">
                {{ r.user }} <small>({{ r.inserted_at }}) </small>
                <br />
                <span class="caption">{{ r.text }}</span>
              </div>
            </v-timeline-item> -->
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ApplicantDetails from "@/components/applicant/ApplicantDetails.vue";
import AddressDetails from "@/components/applicant/AddressDetails.vue";
import EducationDetails from "@/components/applicant/EducationDetails.vue";
import DeclarationDetails from "@/components/applicant/DeclarationDetails.vue";
import { applicantPayload } from "@/helpers/payload";
import { cloneDeep } from "lodash";

export default {
  components: {
    ApplicantDetails,
    AddressDetails,
    EducationDetails,
    DeclarationDetails,
  },
  data() {
    return {
      activeTab: 0,
      form: {},
      validation: {
        applicant: false,
        address: false,
        education: false,
      },
      dialog: false,
      pendingReasons: [],
    };
  },
  props: {
    applicant: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: true,
    },
    qualifications: {
      type: Array,
      required: true,
    },
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "instant" }); // Smooth scrolling
      });
    },
  },
  computed: {
    isAdmitted() {
      return (
        (this.form?.applicant?.application_status || "")
          .toString()
          .toLowerCase() === "admitted"
      );
    },
    effectiveReadOnly() {
      return this.isReadOnly || this.isAdmitted;
    },
    isDetailsValid() {
      return this.validation.applicant;
    },
    isAddressValid() {
      return this.validation.address;
    },
    isEducationValid() {
      return this.validation.education;
    },
  },
  async created() {
    this.form = { ...this.applicant };
    const reasons = await this.$axios.get(
      `/pending_reasons?applicant_detail_id=${this.form.applicant.id}`,
    );
    this.pendingReasons = reasons.data.data;
  },
  methods: {
    getTimeAgo(dateStr) {
      const [date, time] = dateStr.split(" ");
      const [day, month, year] = date.split("-").map(Number);
      const [hours, minutes, seconds] = time.split(":").map(Number);

      const insertedAt = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds,
      );
      const now = new Date();

      const diffMs = now - insertedAt;
      const diffSec = Math.floor(diffMs / 1000);
      const diffMin = Math.floor(diffSec / 60);
      const diffHr = Math.floor(diffMin / 60);
      const diffDay = Math.floor(diffHr / 24);

      if (diffSec < 60)
        return `${diffSec} second${diffSec === 1 ? "" : "s"} ago`;
      if (diffMin < 60)
        return `${diffMin} minute${diffMin === 1 ? "" : "s"} ago`;
      if (diffHr < 24) return `${diffHr} hour${diffHr === 1 ? "" : "s"} ago`;
      return `${diffDay} day${diffDay === 1 ? "" : "s"} ago`;
    },
    validateTab(event, tab) {
      this.validation[tab] = event;
    },
    async updateApplicant(id, formData) {
      try {
        // Send via Axios or Fetch
        const response = await this.$axios.put(
          `/applicant_details/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );
        return response;
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response,
        );
        throw errorMessage;
      }
    },
    async handleApplicantDetailsSubmit(applicantFormData) {
      try {
        const formData = new FormData();
        const applicantData = cloneDeep(applicantFormData);

        // Extract file fields
        const fileFields = [
          { id: "aadharImage", key: "aadhar" },
          { id: "panImage", key: "pan" },
          { id: "photoImage", key: "photo" },
        ];
        fileFields.forEach((item) => {
          if (applicantData[item.id] instanceof File) {
            formData.append(
              item.key,
              applicantData[item.id],
              applicantData[item.id].name,
            );
          }
          delete applicantFormData[item.id]; // Remove from object to avoid duplication
          delete applicantFormData[item.key]; // Remove from object to avoid duplication
        });

        // Append JSON object
        formData.append("attrs", JSON.stringify(applicantFormData));

        const response = await this.updateApplicant(
          this.form.applicant.id,
          formData,
        );

        this.form = applicantPayload(this.qualifications, response.data.data);
        this.activeTab = 1;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error,
          color: "error",
        });
      }
    },
    async handleAddressDetailsSubmit(addressFormData) {
      try {
        const formData = new FormData();
        let step = this.form.applicant.step > 2 ? this.form.applicant.step : 2;

        // Append JSON object
        formData.append("attrs", JSON.stringify({ ...addressFormData, step }));

        const response = await this.updateApplicant(
          this.form.applicant.id,
          formData,
        );

        this.form = applicantPayload(this.qualifications, response.data.data);
        this.activeTab = 2;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error,
          color: "error",
        });
      }
    },
    async handleEducationDetailsSubmit(educationFormData, applicantMap) {
      try {
        const formData = new FormData();
        const fileFields = [
          { id: "idCard", key: "id_card" },
          { id: "employmentLetter", key: "employment_letter" },
          { id: "kovidaCertificate", key: "kovida_certificate" },
        ];
        fileFields.forEach((item) => {
          if (applicantMap[item.id] instanceof File) {
            formData.append(
              item.key,
              applicantMap[item.id],
              applicantMap[item.id].name,
            );
          }
          delete applicantMap[item.id];
          delete applicantMap[item.key];
        });
        const filteredEducationData = educationFormData.map((item) => {
          const { newUploadImage, newUploadCertificate, ...rest } = item; // Extract file field
          if (newUploadImage instanceof File) {
            formData.append(
              item.qualification_id,
              newUploadImage,
              newUploadImage.name,
            );
          }
          if (newUploadCertificate instanceof File) {
            formData.append(
              item.qualification_id + "_certificate",
              newUploadCertificate,
              newUploadCertificate.name,
            );
          }
          delete rest.upload_image;
          return rest;
        });

        let map = { ...applicantMap };
        map.education = filteredEducationData;
        map.step = this.form.applicant.step > 3 ? this.form.applicant.step : 3;

        // Append JSON object
        formData.append("attrs", JSON.stringify(map));

        const response = await this.updateApplicant(
          this.form.applicant.id,
          formData,
        );

        this.form = applicantPayload(this.qualifications, response.data.data);

        this.activeTab = 3;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error,
          color: "error",
        });
      }
    },
  },
};
</script>

<style scoped></style>
